"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
// ErrorCode to share everywhere and reduce replications
// Do NOT put anything secret here
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["HOME_NOT_FOUND"] = "HOME_NOT_FOUND";
    ErrorCode["INVALID_FLOOD_ZONE"] = "INVALID_FLOOD_ZONE";
    // be aware of the difference
    ErrorCode["UNKNOWN_FLOOD_ZONE"] = "UNKNOWN_FLOOD_ZONE";
    ErrorCode["CANNOT_GET_FLOOD_ZONE"] = "CANNOT_GET_FLOOD_ZONE";
    ErrorCode["SSN_COMPLETION_ERROR"] = "SSN_COMPLETION_ERROR";
    ErrorCode["SSN_MATCHES_PRIMARY_APPLICANT"] = "SSN_MATCHES_PRIMARY_APPLICANT";
    ErrorCode["BORROWER_IDENTITY_CONFLICT"] = "BORROWER_IDENTITY_CONFLICT";
    ErrorCode["FULL_SSN_REQUIRED"] = "FULL_SSN_REQUIRED";
    ErrorCode["RECOVERED_SSN_MISMATCH"] = "RECOVERED_SSN_MISMATCH";
    ErrorCode["PARTNER_INQUIRY_EXPIRED"] = "PARTNER_INQUIRY_EXPIRED";
    ErrorCode["PARTNER_INQUIRY_EXISTING_ACCOUNT"] = "PARTNER_INQUIRY_EXISTING_ACCOUNT";
    ErrorCode["PARTNER_INQUIRY_REPEAT_APPLICANT_IN_SAME_SUB_ORG"] = "PARTNER_INQUIRY_REPEAT_APPLICANT_IN_SAME_SUB_ORG";
    ErrorCode["PARTNER_INQUIRY_REPEAT_APPLICANT"] = "PARTNER_INQUIRY_REPEAT_APPLICANT";
    ErrorCode["PRIOR_APPLICATION_FOUND_FOR_COAPPLICANT"] = "PRIOR_APPLICATION_FOUND_FOR_COAPPLICANT";
    ErrorCode["TEXAS_CO_APPLICANT_MARRIED_TO_SOMEONE_ELSE"] = "TEXAS_CO_APPLICANT_MARRIED_TO_SOMEONE_ELSE";
    ErrorCode["TEXAS_CO_APPLICANT_MARRIAGE_ANSWER_MISSING"] = "TEXAS_CO_APPLICANT_MARRIAGE_ANSWER_MISSING";
    ErrorCode["CO_APPLICANT_NOT_ALLOWED_BY_POLICY"] = "CO_APPLICANT_NOT_ALLOWED_BY_POLICY";
    // Phone consistency with approved applicants, checked at PII submission
    ErrorCode["PHONE_MISMATCH_FOR_EXISTING_CUSTOMER"] = "PHONE_MISMATCH_FOR_EXISTING_CUSTOMER";
    ErrorCode["PHONE_NUMBER_TAKEN_BY_ANOTHER_CUSTOMER"] = "PHONE_NUMBER_TAKEN_BY_ANOTHER_CUSTOMER";
    ErrorCode["APPROVED_SAME_PRODUCT_ACCOUNT_EXISTS"] = "APPROVED_SAME_PRODUCT_ACCOUNT_EXISTS";
    ErrorCode["TERMINAL_LOAN_APPLICATION_STATUS"] = "TERMINAL_LOAN_APPLICATION_STATUS";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
